import React, { Component } from 'react';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import logo from '../images/alumsumlogo.png';
import betaLogo from '../images/alumsumlogotm.png';
import Group8 from '../art/images/stepper 3.png';
import './onboarding.css';
import {withRouter, Link} from "react-router-dom";
import {RadioGroup, Radio} from 'react-radio-group';

class OnboardingOthers3 extends Component{
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    emptyItem = {
        expenses: '',
        aggressive: '',
        refinance: ''
    };

    constructor(props) {
        super(props);
        const {cookies} = props;
        this.state = {
            item: this.emptyItem,
            csrfToken: cookies.get('XSRF-TOKEN'),
            expenseValue: '',
            aggressiveValue: '',
            refinanceValue: ''
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        let item = {...this.state.item};
        item[name] = value;
        this.setState({item});
    }
    async handleSubmit(event) {
        event.preventDefault();
        const {item, csrfToken} = this.state;

        await fetch('/user' + (item.id ? '/' + item.id : ''), {

            method: (item.id) ? 'PUT' : 'POST',
            headers: {
                'X-XSRF-TOKEN': csrfToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(item),
            credentials: 'include'
        });
        this.props.history.push('/user');
    }
    render(){
        const {item} = this.state;
        item.enabled = true;
        return(
            <div>
                <Link to="/"><img src={betaLogo} alt="logo" className="responsiveLogo"/></Link>

                <div className="stepperline">
                    <img src={Group8} className="responsive" alt ="group 8"/>
                    <br>
                    </br>
                    <div className="onboardothersrectangle">
                        <div className="This-additional-info">
                            <p>This additional info helps us provide you tailored recommendations
                                and comparisons. Providing this is optional and can be done later.
                            </p>
                        </div>
                        <div className="This-additional-info-questions">
                            <form onSubmit={this.handleSubmit}>
                            <label for="expenses" className="currentjob">Would you rather cut expenses or increase income?</label>
                                    <RadioGroup className="radioGroup" name="expenses" selectedValue={this.state.expenseValue} onChange={this.handleChange}>
                                        <label className="radioLabel">
                                            <Radio value={item.expenses || ''} /> Cut expenses - spend less money so I can pay more towards loans
                                        </label>
                                        <label className="radioLabel">
                                            <Radio value={item.expenses || ''} /> Increase income - earn more money (ex: New Job) to pay loans
                                        </label>
                                    </RadioGroup>
                                <label for="aggressive" className="currentjob">How aggressive are you in paying off your loan debt?</label>
                                    <RadioGroup className="radioGroup" name="aggressive" selectedValue={this.state.aggressiveValue} onChange={this.handleChange}>
                                        <label className="radioLabel">
                                            <Radio value={item.aggressive || ''} /> Low - I'm making minimum payments, but no more.
                                        </label>
                                        <label className="radioLabel">
                                            <Radio value={item.aggressive || ''} /> Medium - Making extra payments when possible.
                                        </label>
                                        <label className="radioLabel">
                                            <Radio value={item.aggressive || ''} /> Aggressive - Paying beyond minimum, making extra payments.
                                        </label>
                                    </RadioGroup>
                                <label for="refinance" className="currentjob">Are you interested in refinancing or consolodating your loans?</label>
                                    <RadioGroup className="radioGroup" name="refinance" selectedValue={this.state.refinanceValue} onChange={this.handleChange}>
                                        <label className="radioLabel">
                                            <Radio value={item.refinance || ''} /> Yes
                                        </label>
                                        <label className="radioLabel">
                                            <Radio value={item.refinance || ''} /> Maybe
                                        </label>
                                        <label className="radioLabel">
                                            <Radio value={item.refinance || ''} /> No
                                        </label>
                                    </RadioGroup>
                                <button className="backbutton3" type="submit">Continue</button>
                            </form>
                            <table>
                                <td>
                                    {/* <button className="backbutton3" type="submit">update</button> */}
                                </td>
                            </table>
                        </div>

                        <a className="skipnow" href="/alumsum/users">Skipnow</a>

                    </div>
                </div>
            </div>
        );
    }
}
export default withCookies(withRouter(OnboardingOthers3));